import {HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {TokenService} from '../services/token.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const tokenService = inject(TokenService);
    const token = tokenService.getToken();

    if (token) {
        const clonedRequest = req.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`,
                'walletTenantId': 'liquidpay',
                'X-Client-Key': 'KYyGAE5iBrJ6KCdcc2xDPHcdsUIMDBEL'
            }
        });
        return next(clonedRequest);
    }

    return next(req);
};

